export default {
  ["Дата начала продаж {date}"]: (date?: string) =>
    `Fecha de inicio de ventas ${date}`,
  ["Закрыть"]: "Cerrar",
  ["Рекламный слайдер"]: "Deslizador publicitario",
  ["Используйте клавиши стрелок для переключения слайдов."]:
    "Use las teclas de flecha para cambiar las diapositivas.",
  ["Ещё"]: "Más",
  ["Ещё {number}"]: (number?: number) => `${number} más`,
  ["Убрать"]: "Eliminar",
  ["Меню"]: "Menú",
  ["От {min} до {max} символов"]: (data?: { min: number; max: number }) =>
    `De ${data?.min} a ${data?.max} caracteres`,
  ["Минимум {count} символ"]: (count?: number) => `Mínimo ${count} caracteres`,
  ["Выбрать из списка"]: "Seleccionar de la lista",
  ["развернуто"]: "Expandido",
  ["свернуто"]: "Colapsado",
  ["Модальное окно"]: "Ventana modal",
  ["Выбран"]: "Seleccionado",
  ["Не выбран"]: "No seleccionado",
  ["Свернуть"]: "Colapsar",
  ["Эксклюзив"]: "Exclusivo",
  ["Хит продаж"]: "Éxito de ventas",
  ["Новинка"]: "Novedad",
  ["Все книги, получившие эту награду"]:
    "Todos los libros que recibieron este premio",
  ["Предыдущий слайд"]: "Diapositiva anterior",
  ["Следующий слайд"]: "Siguiente diapositiva",
  ["Оценить книгу на {count} балл из 5"]: (count: number | undefined = 0) =>
    `Calificar el libro con ${count} ${count > 1 ? "puntos" : "punto"} de 5`,
  ["Снять оценку"]: "Eliminar calificación",
  ["{star} звезда из 5"]: (star: number | undefined = 0) =>
    `${star} ${star > 1 ? "estrellas" : "estrella"} de 5`,
  ["предыдущий таб"]: "Pestaña anterior",
  ["следующий таб"]: "Siguiente pestaña",
};
